
import React, { Component } from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import SideNav from './Nav/SideNav';
import ReactMarkdown from 'react-markdown';
import { useLocation } from 'react-router-dom';
import remarkGfm from 'remark-gfm'
import BreadcrumbMaker from './BreadcrumbMaker';
import Page404 from './Page404'
import $ from 'jquery'
import MarkdownRenderer from './MarkdownRenderer';

export default class App extends Component {

    constructor() {
        super();
        this.state = { markdown: '' };
        this.navData = new SideNav().getList();
    }

    componentWillMount() {
        if (window.location.pathname == "/") {
            fetch("/docs/content.md").then(res => res.text()).then(text => this.setState({ markdown: text }));
        } else if (null == this.navData[window.location.pathname]) {
            this.setState({markdown: "**Page Not Found**"});
            return ;
        } else {
            fetch(window.location.pathname + ".md").then(res => res.text()).then(text => this.setState({ markdown: text }));
        }

        $.getScript("/assets/js/documentation-2.js", function(){});

        if (window.location.href.includes("#")) {

            setTimeout(function () {
                window.location.href = window.location.href;
            }, 1000)
        }
    }

    componentDidMount() {

    }

    render() {

        if (null == this.navData[window.location.pathname] && window.location.pathname != "/") {
            return <Page404 />
        }

        const { markdown } = this.state;

        return (
            <div style={{marginTop:'104px'}}>
                <div className="main-wrapper">
                    <Header />
                    <section className="custom-documentation-section">
                        <div className="documentation-mobile-toggle">
                            <h5>Docs Menu</h5>
                            <div className="dmt-button">
                                <i className="fa-regular fa-chevrons-down"></i>
                            </div>
                        </div>
                        <div className="d-flex">

                            <SideNav />

                            <div className="doc-arrodian-toggle dct2">
                                <i className="fa-solid fa-angles-right"></i>
                            </div>

                            <div className="conentSection px-0">
                                <div className="panelContainer">
                                    <div id="getting_started" className="panel" style={{display: 'block'}}>
                                        <div className="tab-content-wrap">

                                            <BreadcrumbMaker data={this.navData} />
                                            <MarkdownRenderer markdown={markdown} />

                                            <section className="cta-subscribe mt-5" style={{display:'none'}}>
                                                <div
                                                    className="cta-gradient ptb-60 position-relative rounded-custom">
                                                    <div className="row justify-content-center">
                                                        <div className="col-lg-10 col-md-10">
                                                            <div
                                                                className="subscribe-info-wrap text-center position-relative z-2">
                                                                <div className="section-heading sec-cta">
                                                                    <h2>Get started for FREE</h2>
                                                                    <p>Create your APIs easily by saving up to
                                                                        65% time on
                                                                        development. </p>
                                                                </div>
                                                                <div className="action-btns text-center pt-4">
                                                                    <a target="_blank"
                                                                       href="https://cloud.syncloop.com/"
                                                                       className="btn get_ct_btn me-lg-1 me-sm-3">Get
                                                                        started for
                                                                        FREE</a>
                                                                    <a href="pricing.html"
                                                                       className="btn gt-outline">View Pricing &
                                                                        Plans</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>


                                            <div className="cta-subscribe mt-5">
                                                <div
                                                    className="cta-join-conver ptb-60 position-relative overflow-hidden rounded-custom">
                                                    <div className="row justify-content-center">
                                                        <div className="col-lg-10 col-md-10">
                                                            <div
                                                                className="subscribe-info-wrap text-center position-relative z-2 price-wrp">
                                                                <div
                                                                    className="section-heading sec-cta aos-init aos-animate"
                                                                    data-aos="fade-up" data-aos-delay="50">
                                                                    <h2>Join the conversation</h2>
                                                                    <p>Be an integral part of our knowledge
                                                                        exchange</p>
                                                                </div>
                                                                <div
                                                                    className="action-btns text-center covrs aos-init aos-animate"
                                                                    data-aos="fade-up" data-aos-delay="100">
                                                                    <a target="_blank"
                                                                       href="https://discord.com/invite/EnazFJpGQs?utm_source=Website&utm_medium=click&utm_id=discord&utm_content=bottom">
                                                                        <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 800 800"
      version="1.1"
      viewBox="0 0 800 800"
      xmlSpace="preserve"
    >
      <path
        d="M659.9 161.6c-48.6-22.3-99.9-38.2-152.7-47.3-1-.2-2 .3-2.5 1.2-6.6 11.7-13.9 27-19 39.1-56.8-8.6-114.6-8.6-171.5 0-5.7-13.4-12.1-26.4-19.3-39.1-.5-.9-1.5-1.3-2.5-1.2-52.7 9.1-104 25-152.7 47.3-.4.2-.8.5-1 .8-97 145.3-123.7 287-110.6 426.9.1.7.4 1.3 1 1.8a621.97 621.97 0 00187.2 94.6c1 .3 2-.1 2.6-.9 14.5-19.7 27.3-40.5 38.3-62.3.6-1.2.1-2.6-1-3.2-.1 0-.2-.1-.3-.1-20.2-7.7-39.8-17.1-58.5-27.9-1.2-.7-1.5-2.1-.9-3.3.2-.3.4-.5.6-.7 3.9-3 7.8-6 11.6-9.1.7-.6 1.6-.7 2.4-.3 122.7 56 255.6 56 376.9 0 .8-.4 1.8-.3 2.4.3 3.7 3.1 7.7 6.2 11.7 9.1 1.1.8 1.3 2.3.5 3.4-.2.2-.4.4-.7.6-18.7 10.9-38.3 20.2-58.5 27.9-1.2.5-1.9 1.9-1.4 3.1 0 .1.1.2.1.2 11.2 21.8 24.1 42.6 38.3 62.3.6.8 1.7 1.2 2.6.9A620.88 620.88 0 00770.6 591c.6-.4.9-1 1-1.7 15.6-161.8-26.2-302.3-110.9-426.9 0-.3-.4-.7-.8-.8zM275.6 504.1c-37 0-67.4-33.9-67.4-75.6s29.9-75.6 67.4-75.6c37.8 0 68 34.2 67.4 75.6 0 41.7-29.8 75.6-67.4 75.6zm249.2 0c-37 0-67.4-33.9-67.4-75.6s29.8-75.6 67.4-75.6c37.8 0 68 34.2 67.4 75.6 0 41.7-29.5 75.6-67.4 75.6z"
        className="cv_color"
      ></path>
    </svg>
                                                                    </a>
                                                                    <a target="_blank"
                                                                       href="https://www.youtube.com/@syncloop">
                                                                        <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 800 800"
      version="1.1"
      viewBox="0 0 800 800"
      xmlSpace="preserve"
    >
      <path
        d="M323.3 511.5v-223l196 111.5-196 111.5zm436-293.2c-8.9-32.5-33.9-57.7-65.6-66.6l-.7-.2c-79.8-10.2-172.2-16-265.9-16-9.5 0-19 .1-28.5.2h1.5c-8.1-.1-17.5-.2-27.1-.2-93.7 0-186.1 5.8-276.8 17l10.9-1.1c-32.4 9.1-57.4 34.2-66.1 66.1l-.2.7C30.7 271 25 331.7 25 393.7v6.6-.4 6.3c0 62 5.7 122.7 16.7 181.5l-1-6.1c8.9 32.5 33.9 57.7 65.6 66.6l.7.2c79.8 10.2 172.2 16 265.9 16 9.5 0 19-.1 28.5-.2h-1.5c8.1.1 17.6.2 27.1.2 93.7 0 186.1-5.8 276.8-17l-10.9 1.1c32.5-9.1 57.5-34.2 66.2-66.1l.2-.7c10-52.7 15.7-113.4 15.7-175.4v-6.6-6c0-62-5.7-122.7-16.7-181.5l1 6.1z"
        className="cv_color"
      ></path>
    </svg>
                                                                    </a>
                                                                    <a target="_blank"
                                                                       href="https://twitter.com/Syncloop_dev">
                                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                                             x="0px" y="0px" width="26"
                                                                             height="26" viewBox="0 0 26 26">
                                                                            <path className="cv_color"
                                                                                  d="M 25.855469 5.574219 C 24.914063 5.992188 23.902344 6.273438 22.839844 6.402344 C 23.921875 5.75 24.757813 4.722656 25.148438 3.496094 C 24.132813 4.097656 23.007813 4.535156 21.8125 4.769531 C 20.855469 3.75 19.492188 3.113281 17.980469 3.113281 C 15.082031 3.113281 12.730469 5.464844 12.730469 8.363281 C 12.730469 8.773438 12.777344 9.175781 12.867188 9.558594 C 8.503906 9.339844 4.636719 7.246094 2.046875 4.070313 C 1.59375 4.847656 1.335938 5.75 1.335938 6.714844 C 1.335938 8.535156 2.261719 10.140625 3.671875 11.082031 C 2.808594 11.054688 2 10.820313 1.292969 10.425781 C 1.292969 10.449219 1.292969 10.46875 1.292969 10.492188 C 1.292969 13.035156 3.101563 15.15625 5.503906 15.640625 C 5.0625 15.761719 4.601563 15.824219 4.121094 15.824219 C 3.78125 15.824219 3.453125 15.792969 3.132813 15.730469 C 3.800781 17.8125 5.738281 19.335938 8.035156 19.375 C 6.242188 20.785156 3.976563 21.621094 1.515625 21.621094 C 1.089844 21.621094 0.675781 21.597656 0.265625 21.550781 C 2.585938 23.039063 5.347656 23.90625 8.3125 23.90625 C 17.96875 23.90625 23.25 15.90625 23.25 8.972656 C 23.25 8.742188 23.246094 8.515625 23.234375 8.289063 C 24.261719 7.554688 25.152344 6.628906 25.855469 5.574219"></path>
                                                                        </svg>
                                                                    </a>
                                                                    <a target="_blank"
                                                                       href="https://www.linkedin.com/company/syncloop/">
                                                                        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      x="0"
      y="0"
      viewBox="0 0 30 30"
    >
      <path
        d="M9 25H4V10h5v15zM6.501 8a2.5 2.5 0 110-5.001A2.5 2.5 0 016.5 8zM27 25h-4.807v-7.3c0-1.741-.033-3.98-2.499-3.98-2.503 0-2.888 1.896-2.888 3.854V25H12V9.989h4.614v2.051h.065c.642-1.18 2.211-2.424 4.551-2.424 4.87 0 5.77 3.109 5.77 7.151V25z"
        className="cv_color"
      ></path>
    </svg>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer />
                </div>
            </div>
        )
    }
}
